import { CheckCircle, XCircle, Info, X } from 'lucide-react';
import { useToastStore } from '../store/toastStore';

const ICONS = {
  success: <CheckCircle size={16} className="text-emerald-400" strokeWidth={1.5} />,
  error:   <XCircle    size={16} className="text-red-400"     strokeWidth={1.5} />,
  info:    <Info       size={16} className="text-blue-400"    strokeWidth={1.5} />,
};

const BORDERS = {
  success: 'border-emerald-800/50',
  error:   'border-red-900/50',
  info:    'border-blue-800/50',
};

export function ToastContainer() {
  const { toasts, dismiss } = useToastStore();
  if (toasts.length === 0) return null;

  return (
    <div
      aria-live="polite"
      aria-atomic="false"
      className="fixed bottom-4 right-4 z-[200] flex flex-col gap-2 max-w-sm w-full pointer-events-none"
    >
      {toasts.map((toast) => (
        <div
          key={toast.id}
          className={`flex items-center gap-3 bg-felt-800 border ${BORDERS[toast.type]}
                      rounded-xl px-4 py-3 shadow-2xl pointer-events-auto
                      animate-fade-in`}
        >
          {ICONS[toast.type]}
          <p className="flex-1 text-white text-sm font-medium">{toast.message}</p>
          <button
            onClick={() => dismiss(toast.id)}
            aria-label="Dismiss"
            className="text-gray-500 hover:text-white transition-colors shrink-0
                       focus-visible:ring-2 focus-visible:ring-gold-400 outline-none rounded"
          >
            <X size={14} strokeWidth={2} />
          </button>
        </div>
      ))}
    </div>
  );
}
